export const SELLER = {
  name: "Chandigarh Industrial Corporation",
  address: "305, Industrial Area, Phase II",
  city: "Chandigarh",
  pincode: "160002",
  country: "India",
  gstin: "04AEUPK0203R1Z9",
  email: "furniturecic@gmail.com",
  phone: "+91 9501798358",
  state: "Chandigarh",
  stateCode: "04",
};

export const BANK = {
  name: "Punjab National Bank",
  branch: "Industrial Area, Phase-2, Chandigarh",
  account: "3247002100150236",
  ifsc: "PUNB0324700",
};

export const TERMS = [
  "Return period is 7 days.",
  "Only store credit will be provided for returned products.",
  "All disputes subject to Chandigarh Jurisdiction only.",
];

export const DEFAULT_GST_RATE = 18;

export const INDIAN_STATES = [
  { name: "Andhra Pradesh", code: "37" },
  { name: "Arunachal Pradesh", code: "12" },
  { name: "Assam", code: "18" },
  { name: "Bihar", code: "10" },
  { name: "Chandigarh", code: "04" },
  { name: "Chhattisgarh", code: "22" },
  { name: "Delhi", code: "07" },
  { name: "Goa", code: "30" },
  { name: "Gujarat", code: "24" },
  { name: "Haryana", code: "06" },
  { name: "Himachal Pradesh", code: "02" },
  { name: "Jharkhand", code: "20" },
  { name: "Karnataka", code: "29" },
  { name: "Kerala", code: "32" },
  { name: "Madhya Pradesh", code: "23" },
  { name: "Maharashtra", code: "27" },
  { name: "Manipur", code: "14" },
  { name: "Meghalaya", code: "17" },
  { name: "Mizoram", code: "15" },
  { name: "Nagaland", code: "13" },
  { name: "Odisha", code: "21" },
  { name: "Punjab", code: "03" },
  { name: "Rajasthan", code: "08" },
  { name: "Tamil Nadu", code: "33" },
  { name: "Telangana", code: "36" },
  { name: "Uttar Pradesh", code: "09" },
  { name: "Uttarakhand", code: "05" },
  { name: "West Bengal", code: "19" },
];
